import React, {useEffect, useState} from "react";
import GetFieldValue from "../../functions/GetFieldValue";

export interface AddFieldsProps {
    title?: string,
    items: Array<{
        field_code: string|null,
        field_id: number,
        field_name: string
        field_type: string,
        values: Array<{
            value: string
        }>
    }>
}

const AddFields: React.FunctionComponent<AddFieldsProps> = ({title, items}) => {

    const [showAll, turnShowAll] = useState<boolean>(false)

    const [divTitle, setTitle] = useState<string>("")

    useEffect(() => {

        let niceItems = items.filter(item => item.field_id === 1 || item.field_id === 2)


        setTitle(niceItems.sort((a, b) => {
            return b.field_id - a.field_id
        }).map((item) => {
            return item.values[0].value
        }).join(". "))

    }, [items])

    return (
        <div className="AmoTools__Provider">
            <span className="AmoTools__Provider__Title">{title}</span>

            <div className="AmoTools__Provider__Info">
                {
                    divTitle.length > 0 ?  <span className="AmoTools__Provider__Info__Name">{divTitle}</span> : ""
                }

                <div className="AmoTools__Provider__Info__List">
                    {
                        items.filter(item => item.field_type !== "legal_entity").filter(item => item.field_id !== 1 && item.field_id !== 2).slice(0, 3).map((item) => {
                            return (
                                <div key={item.field_id} className="AmoTools__Provider__Info__List__Item">
                                    <span>{item.field_name}</span>
                                    <span>{GetFieldValue(item)}</span>
                                </div>
                            )
                        })
                    }
                    {showAll ? (
                        <>
                            {
                                items.filter(item => item.field_type !== "legal_entity").filter(item => item.field_id !== 1 && item.field_id !== 2).slice(3).map((item) => {
                                    return (
                                        <div key={item.field_id} className="AmoTools__Provider__Info__List__Item">
                                            <span>{item.field_name}</span>
                                            <span>{GetFieldValue(item)}</span>
                                        </div>
                                    )
                                })
                            }
                        </>
                    ): ""}
                </div>
            </div>

            {
                items.filter(item => item.field_type !== "legal_entity").filter(item => item.field_id !== 1 && item.field_id !== 2).length > 3 ? (
                    <div className="AmoTools__Provider__ShowMore">
                        <span className="AmoTools__Provider__ShowMore__Inner" onClick={(e) => {turnShowAll(!showAll)}}>
                            {showAll ? "Свернуть" : "Показать всё"}
                        </span>
                    </div>
                ) : ""
            }
        </div>
    )

}

export default AddFields